import React from "react";

import { ApiGpdGpdsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { gpdInformation } from "../types";

type Props = {
  searchField: keyof ApiGpdGpdsListRequest;
  setSearchField: (searchField: keyof ApiGpdGpdsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GpdFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={gpdInformation}
    />
  );
};

export { GpdFilters };
